import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./AuthForms.css"; // Import the CSS file

const SetPassword = () => {
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        setMessage("");

                // ✅ Enforce minimum password length
            if (newPassword.length < 8) {
                setError("Password must be at least 8 characters long.");
                setLoading(false);
                return;
            }



        try {
            const { data } = await axios.post("https://payweek.com/api/set-password", {
            //const { data } = await axios.post("http://localhost:5000/set-password", {
                email,
                otp,
                newPassword,
            });
            alert("Password is changed");
            setMessage(data.message || "Password reset successful.");
            navigate("/emp-login");
        } catch (err) {
            console.error(err);
            setError(err.response?.data?.error || "Error resetting password.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <h2>Set Password</h2>
                {message && <p className="auth-message auth-success">{message}</p>}
                {error && <p className="auth-message auth-error">{error}</p>}
                <form onSubmit={handleSubmit} className="auth-form">
                    <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="auth-input"
                    />
                    <input
                        type="text"
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        required
                        className="auth-input"
                    />
                    <input
                        type="password"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                        className="auth-input"
                    />
                    <button type="submit" disabled={loading} className="auth-button">
                        {loading ? "Resetting..." : "Reset Password"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default SetPassword;
